import React, { useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { sourceLabel } from "@/components/admin/ReportsTab";

const STATUSES = ["pending", "confirmed", "completed", "cancelled"];

export const AppointmentsTab = ({ appointments, refresh }) => {
  const [source, setSource] = useState("all");
  const sources = Array.from(new Set(appointments.map((a) => a.src || "direct"))).sort();
  const visible = appointments.filter((a) => source === "all" || (a.src || "direct") === source);

  const setStatus = async (id, status) => {
    await api.put(`/appointments/${id}/status`, { status });
    refresh();
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <span className="overline">Source</span>
        <Select value={source} onValueChange={setSource}>
          <SelectTrigger className="w-44 h-8 text-xs" data-testid="appt-source-filter">
            <SelectValue placeholder="Source" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All sources</SelectItem>
            {sources.map((s) => <SelectItem key={s} value={s}>{sourceLabel(s)}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {visible.map((a) => (
        <Card key={a.id} className="border-border">
          <CardContent className="p-5 flex items-center justify-between">
            <div>
              <div className="font-medium">{a.user_name} <span className="text-xs text-muted-foreground">· {a.user_email}</span></div>
              <div className="text-sm">{a.date} · {a.time_slot} · {a.consultation_type}</div>
              <div className="text-xs text-muted-foreground mt-1">{a.reason}</div>
              <div className="flex items-center gap-1.5 mt-1.5">
                <Badge variant="outline" className="text-[10px]" data-testid={`appt-src-${a.id}`}>
                  {sourceLabel(a.src)}
                </Badge>
                {a.ref && (
                  <Badge variant="outline" className="text-[10px] border-primary/30 text-primary bg-primary/5"
                         data-testid={`appt-ref-${a.id}`}>
                    {a.ref}
                  </Badge>
                )}
              </div>
            </div>
            <Select value={a.status} onValueChange={(v) => setStatus(a.id, v)}>
              <SelectTrigger className="w-36" data-testid={`appt-status-${a.id}`}><SelectValue/></SelectTrigger>
              <SelectContent>
                {STATUSES.map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}
              </SelectContent>
            </Select>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AppointmentsTab;
